export default "__VITE_ASSET__BoURY0$S__"